// extracted by mini-css-extract-plugin
module.exports = {"info":"StudentInfo_info__1Ymgm","nested":"StudentInfo_nested__1TL1s","changer":"StudentInfo_changer__h8fXg"};